import { render, staticRenderFns } from "./the-loop.vue?vue&type=template&id=0efc5290&lang=pug&"
import script from "./the-loop.vue?vue&type=script&lang=js&"
export * from "./the-loop.vue?vue&type=script&lang=js&"
import style0 from "./the-loop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efc5290')) {
      api.createRecord('0efc5290', component.options)
    } else {
      api.reload('0efc5290', component.options)
    }
    module.hot.accept("./the-loop.vue?vue&type=template&id=0efc5290&lang=pug&", function () {
      api.rerender('0efc5290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/the-loop.vue"
export default component.exports